import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaUser,
  FaBriefcase,
  FaGlobe,
  FaQuoteLeft,
  FaYenSign,
  FaUsers,
  FaRegClock,
  FaPhoneAlt,
  FaEnvelope,
  FaFilePdf,
} from 'react-icons/fa';
import Hero from '../../components/Hero/Hero';
import iso9001Img from '../../assets/images/about/iso-9001.png';
import iso14001Img from '../../assets/images/about/iso-14001.png';
import finishedProductsImg from '../../assets/images/about/finished-products.png';
import heroBg from '../../assets/images/gallery/office/all-staff-faces.png';
import './About.css';

const TBD = <span className="profile-row__tbd">— please provide</span>;

const companyProfile = [
  { icon: <FaBriefcase />, label: 'Company Name', value: 'Tokyo Byokane Philippines Corporation' },
  { icon: <FaCalendarAlt />, label: 'Established', value: 'April 2000' },
  { icon: <FaUser />, label: 'President', value: 'Mr. Ayumi Ishimoto' },
  { icon: <FaBriefcase />, label: 'Business Type', value: 'Logistics Enterprise (Trading / Warehousing)' },
  { icon: <FaYenSign />, label: 'Capital', value: TBD },
  { icon: <FaUsers />, label: 'Employees', value: TBD },
  { icon: <FaRegClock />, label: 'Business Hours', value: 'Monday–Friday, 8:00–17:00 PHT' },
  { icon: <FaMapMarkerAlt />, label: 'Head Office', value: 'Lot C2-6B Carmelray Industrial Park 2, Brgy. Punta, Calamba City, Laguna 4027, Philippines' },
  { icon: <FaPhoneAlt />, label: 'Telephone', value: '+63-49-508-7899 / 7903 / 7904' },
  { icon: <FaEnvelope />, label: 'Email', value: 'sales@tokyobyokane.com.ph' },
  { icon: <FaGlobe />, label: 'Website', value: 'www.tokyobyokane.com.ph' },
];

const About = () => {
  return (
    <div className="about-page">
      <Hero
        title={<>About <span className="highlight">Us</span></>}
        subtitle="Learn about our history, values, and commitment to excellence in industrial fastener distribution."
        backgroundImage={heroBg}
      />

      {/* Company History */}
      <section className="about__history section">
        <div className="container">
          <div className="about__history-content">
            <div className="about__history-text">
              <p className="section-subtitle">Our Story</p>
              <h2 className="section-title">A Legacy of <span className="highlight">Excellence</span></h2>
              <p>
                <strong>Tokyo Byokane</strong> was established in 1941 in Japan, which started as a
                trading shop providing industrial support and services to all industries in Tokyo.
                From then on, Tokyo Byokane had emerged to be one of the finest in the business,
                which led to the establishment of various overseas offices.
              </p>
              <p>
                To answer the demand of its products in the Philippines,
                <strong> Tokyo Byokane Philippines Corporation</strong> was established in 2000.
                The company is engaged in warehousing and distribution of industrial fasteners
                for both mechanical and electrical parts.
              </p>
              <p>
                <strong>Furthermore</strong>, in striving to provide our customers with the total
                manufacturing solution, Byokane has incorporated Factory Automation in its
                manufacturing processes. This enables us to provide both machinery parts and
                other components under one roof.
              </p>
            </div>
            <div className="about__timeline">
              <div className="timeline-item">
                <span className="timeline-item__year">1941</span>
                <span className="timeline-item__text">Tokyo Byokane founded in Japan</span>
              </div>
              <div className="timeline-item">
                <span className="timeline-item__year">2000</span>
                <span className="timeline-item__text">Philippines branch established</span>
              </div>
              <div className="timeline-item">
                <span className="timeline-item__year">Today</span>
                <span className="timeline-item__text">20+ locations across 14 countries</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Profile (会社概要) */}
      <section className="about__profile section">
        <div className="container">
          <p className="section-subtitle">会社概要 · Company Details</p>
          <h2 className="section-title">Company <span className="highlight">Profile</span></h2>
          <div className="profile-table">
            {companyProfile.map((item, idx) => (
              <div className="profile-row" key={idx}>
                <div className="profile-row__label">
                  <span className="profile-row__icon">{item.icon}</span>
                  <span>{item.label}</span>
                </div>
                <div className="profile-row__value">{item.value}</div>
              </div>
            ))}
          </div>
          <div className="about__profile-cta">
            <Link to="/company-profile" className="btn btn-outline">
              <FaFilePdf style={{ marginRight: 8 }} /> Download Company Profile (PDF)
            </Link>
          </div>
        </div>
      </section>

      {/* Quote */}
      <section className="about__quote section">
        <div className="container">
          <div className="about__quote-card">
            <FaQuoteLeft className="about__quote-icon" />
            <blockquote>
              "Coming together is a beginning... Keeping together is progress...
              Working together is success..."
            </blockquote>
            <cite>— Henry Ford</cite>
          </div>
        </div>
      </section>

      {/* Parent Company & ISO */}
      <section className="about__parent section">
        <div className="container">
          <div className="about__parent-grid">
            <div className="about__parent-card">
              <p className="section-subtitle">Parent Company</p>
              <h3>Tokyo Byokane Co., Ltd.</h3>
              <p className="about__parent-address">Yokoami 2-5-14, Sumida-ku, Tokyo-to</p>
              <p className="about__parent-tel">TEL: 03-3626-1221</p>
              <a href="http://www.byokaneworld.com" target="_blank" rel="noopener noreferrer" className="btn btn-outline">
                Visit Parent Website
              </a>
            </div>
            <div className="about__iso-card">
              <p className="section-subtitle">Recognized Standard</p>
              <h3>ISO Certified</h3>
              <div className="about__iso-grid">
                <figure className="about__iso-cert">
                  <img src={iso9001Img} alt="ISO 9001 Certification (SOCOTEC / JAS-ANZ)" />
                  <figcaption>ISO 9001 · Cert No. SCP000038Q</figcaption>
                </figure>
                <figure className="about__iso-cert">
                  <img src={iso14001Img} alt="ISO 14001 Certification (SOCOTEC / UKAS)" />
                  <figcaption>ISO 14001 · Cert No. SCUK001625K</figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Where Our Products End Up */}
      <section className="about__finished section">
        <div className="container">
          <div className="about__finished-grid">
            <div className="about__finished-text">
              <p className="section-subtitle">Finished Products</p>
              <h2 className="section-title">Where Our Fasteners <span className="highlight">End Up</span></h2>
              <p>
                Our industrial fasteners, precision parts, and assembly components are built into
                everyday electronics and industrial equipment — printers, monitors, cameras,
                computing hardware, air-conditioning units, mobile devices, and the printed-circuit
                assemblies that power them.
              </p>
              <p>
                By supplying mechanical and electrical parts under one roof, we help our customers
                keep their production lines running reliably, with full traceability and on-time
                delivery from our Calamba warehouse.
              </p>
            </div>
            <div className="about__finished-image">
              <img src={finishedProductsImg} alt="Examples of finished products that use Tokyo Byokane fasteners" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
